module.exports = __webpack_public_path__ + "static/media/4.ed9311aa.jpg";